/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationMetadataModel } from '../../models/organization-metadata-model';

export interface ApiAdminOrganizationsGet$Params {
}

export function apiAdminOrganizationsGet(http: HttpClient, rootUrl: string, params?: ApiAdminOrganizationsGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<OrganizationMetadataModel>>> {
  const rb = new RequestBuilder(rootUrl, apiAdminOrganizationsGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<OrganizationMetadataModel>>;
    })
  );
}

apiAdminOrganizationsGet.PATH = '/api/Admin/Organizations';
